/**
 * iKSORIS - WWW
 * SoftCOM Spółka jawna - http://www.softcom.wroc.pl
 * @author SoftCOM Spółka jawna <biuro@softcom.wroc.pl>
 * @copyright Copyright (c) 2010-2014, SoftCOM Spółka jawna
 */

import { Tools } from "../utilities/Tools.js";

class Alert {
    static show(config = {}) {
        const defaultConfig = {
            type: "light", // primary, secondary, success, danger, warning, info, light, dark
            headerText: "",
            text: "",
            pre: "",
            preHr: false,
        };

        if (Object.keys(config).length === 0) {
            Object.assign(config, defaultConfig);
        } else {
            for (const key in config) {
                if (Object.hasOwnProperty.call(config, key)) {
                    if (!Object.hasOwnProperty.call(defaultConfig, key)) {
                        throw new Error(key + ": Błędna właściwość w ustawieniach Alerta!");
                    }
                }
            }

            config = Object.assign(defaultConfig, config);
        }

        // W przypadku otwartego okna dialog, alerty będą pojawiać się w oknie dialog.
        let dialog = document.getElementById("dialog");
        let elementSelector = ".main-content";

        if (Boolean(dialog) && dialog.classList.contains("show")) {
            elementSelector = "#dialog .main-content";
        }

        document.querySelector(elementSelector).insertAdjacentHTML(
            "afterbegin",
            `
          <div class="alert alert-${config.type} alert-dismissible fade show" role="alert">
            ${(function (headerText) {
                if (headerText !== "") {
                    return `<h2 class="h6 fw-bold text-uppercase">${headerText}</h2>`;
                } else {
                    return "";
                }
            })(config.headerText)}
            
            ${(function (text, preHr) {
                if (text !== "") {
                    return `<div>${text}</div>`;
                } else {
                    return "";
                }
            })(config.text, config.preHr)}
            
            ${(function (preHr) {
                if (preHr) {
                    return `<hr>`;
                } else {
                    return "";
                }
            })(config.preHr)}
            
            ${(function (pre) {
                if (pre !== "") {
                    return `<pre class="mb-0">${pre}</pre>`;
                } else {
                    return "";
                }
            })(config.pre)}
            <button aria-label="Close" class="btn-close" data-bs-dismiss="alert" type="button"></button>
          </div>`
        );

        if (Boolean(dialog) && dialog.classList.contains("show")) {
            // Po wyświetleniu komunikatu błędu (alert), strona, sekcja zostaje przeskrolowana do góry tak aby można było odczytać błąd.
            Tools.scrollTo(document.querySelector("#dialog .modal-body"), 0);
        } else {
            Tools.scrollTo(document.querySelector("html"), 0);
        }
    }
}

export { Alert };
